<style lang="scss" scoped>
@import "@/styles/variables.scss";
.box-map-container {
    position: relative;
    margin: 0 -30px -30px -30px;
    .map-info-container {
        position: absolute;
        width: 100%;
        z-index: 1;
        display: flex;
        bottom: 15px;
        .map-info-box {
            margin-left: 15px;
            padding: 15px;
            background: #fff;
            border: 1px solid #e3eaee;
        }
    }
}

.flex-none {
    flex: none;
}
.icon {
    width: 15px;
    height: 15px;
}
.detail-images {
    .main-image {
        img {
            width: 100%;
            height: 200px;
            object-fit: cover;
        }
    }
    .images {
        margin: 5px -2.5px 0px -2.5px;
        .extra-image {
            height: 34px;
            width: 12.5%;
            object-fit: cover;
            padding: 0 2.5px;
            margin-bottom: 5px;
        }
    }
}
.detail-box {
    overflow: hidden;
    .detail-row {
        padding: 0 22.5px;
        .header {
            box-shadow: none;
            cursor: pointer;
        }
        &:not(:last-child) {
            .header {
                box-shadow: inset 0px -1px 0 0 #e3eaee;
            }
        }
        .content {
            overflow: hidden;
            height: 0;
            transition: height 0.3s;
        }
        &:not(.open) {
            .header {
                transition: background 0.3s;
                &:hover {
                    background: $body-bg;
                }
            }
        }
        &.open {
            .header {
                box-shadow: none;
            }
            .content {
                height: initial;
            }
            &:not(:last-child) {
                box-shadow: inset 0px -1px 0 0 #e3eaee;
            }
        }
    }
}

.states {
    cursor: pointer;
    &.open {
        .state {
            &.collapsed {
                height: 0;
                padding: 0;
                opacity: 0;
            }
        }
    }
    .state {
        padding: 15px 20px;
        font-weight: $font-weight-normal;
        transition: alls 0.3s;
        &:not(:last-child) {
            border-bottom: 1px solid #e3eaee;
        }
        &.active {
            color: $secondary;
            font-weight: $font-weight-semi-bold;
            .date {
                color: $primary;
            }
        }
        &.new-state {
            background: $body-bg;
            border-radius: 0 0 $border-radius $border-radius;
            cursor: pointer;
        }
    }
}
.driver-car-text {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.attachment-icon {
    width: 54px;
    height: 54px;
    border-radius: 4px;
    border: 1px solid #e3eaee;
    background-color: #e3eaee;
    object-fit: cover;
}
.attachment-icon-remove {
    transition: 0.3s opacity;
    opacity: 0;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    position: absolute;
    font-size: 25px;
    line-height: 15px;
    text-align: center;
    left: 40px;
    cursor: pointer;
    color: #fff;
    top: 20px;
    &:hover {
        opacity: 1;
    }
}
.mb--15 {
    margin-bottom: -15px;
}
.driver-tag {
    background: #e3eaee;
    border-radius: 4px;
    position: absolute;
    left: 15px;
    top: 15px;
}
</style>

<template>
    <div class="row mb-45" v-if="item">

        <div class="col-12 mb-30">
            <a href="#" @click="$router.back()" class="text-secondary mb-0 fs-16 d-flex">
                <svg class="mr-15 my-auto" width="12" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 12 20">
                    <defs>
                        <path d="M65.17822,115.48849c-0.65065,-0.65132 -1.70662,-0.65132 -2.35661,0l-8.33313,8.33313c-0.65132,0.65132 -0.65132,1.70596 0,2.35661l8.33313,8.33313c0.32466,0.32599 0.75131,0.48865 1.17797,0.48865c0.42666,0 0.85331,-0.16266 1.17864,-0.48799c0.65132,-0.65132 0.65132,-1.70596 0,-2.35661l-7.15449,-7.15515l7.15449,-7.15449c0.65065,-0.65132 0.65065,-1.70596 0,-2.35728z" id="Path-0" />
                    </defs>
                    <g transform="matrix(1,0,0,1,-54,-115)">
                        <g>
                            <title>Shape</title>
                            <use xlink:href="#Path-0" fill="#8296a0" fill-opacity="1" />
                        </g>
                    </g>
                </svg> {{ $t('shipments.backto', { to: backText }) }}
            </a>
        </div>

        <!-- Left (Main) panel -->
        <!-- Contains shipment details-->
        <div class="col-12 col-md-8">

            <div v-if="item.offer_id && !item.accepted_offer.assigned" class="empty-box border border-gray d-flex p-30 mb-45">
                <i-no-driver class="i-60 mr-30"></i-no-driver>
                <p class="my-auto fw-semi-bold">{{ $t('shipments.assigndriver') }}</p>
                <a class="btn btn-primary ml-auto my-auto" href="#" @click="showAddDriverPopup = true">Voertuig</a>
            </div>

            <!-- Detail information -->
            <!-- Pickup and delivery times -->
            <box class="mb-45">
                <template slot="content">

                    <div class="row mb-30">
                        <div class="col-12 col-md-6 mb-30 d-flex">
                            <i-marker class="i-30 mr-15 my-auto svg-green"></i-marker>
                            <div>
                                <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ item.pickup_location.address.city }}</p>
                                <p class="mb-0 fs-12 font-weight-light">{{ item.pickup_location.address.formatted }}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 mb-30 d-flex">
                            <i-marker class="i-30 mr-15 my-auto"></i-marker>
                            <div>
                                <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ item.delivery_location.address.city }}</p>
                                <p class="mb-0 fs-12 font-weight-light">{{ item.delivery_location.address.formatted }}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="row" v-if="isSameDay(item.pickup_date_from, item.pickup_date_till, item.pickup_date_timezone)">
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.pickup_on') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.pickup_date_from)).tz(item.pickup_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t(`shipments.times.${checkTime(item.pickup_date_from, item.pickup_date_till, item.pickup_date_timezone)}`) }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.pickup_date_from)).tz(item.pickup_date_timezone).format('HH:mm') }} {{ $t('bin.till') }} {{ $moment.unix(parseInt(item.pickup_date_till)).tz(item.pickup_date_timezone).format('HH:mm') }}</p>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.pickup_from') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.pickup_date_from)).tz(item.pickup_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t(`shipments.times.${checkTime(item.pickup_date_from, item.pickup_date_till, item.pickup_date_timezone)}`) }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.pickup_date_from)).tz(item.pickup_date_timezone).format('HH:mm') }} {{ $t('bin.till') }} {{ $moment.unix(parseInt(item.pickup_date_till)).tz(item.pickup_date_timezone).format('HH:mm') }}</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.till') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.pickup_date_till)).tz(item.pickup_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <disclaimer>{{ $t('shipments.pickuptimezonedisclaimer', { tz: item.pickup_date_timezone }) }}</disclaimer>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6">
                            <div class="row" v-if="isSameDay(item.delivery_date_from, item.delivery_date_till, item.delivery_date_timezone)">
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.delivery_on') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.delivery_date_from)).tz(item.delivery_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t(`shipments.times.${checkTime(item.delivery_date_from, item.delivery_date_till, item.delivery_date_timezone)}`) }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.delivery_date_from)).tz(item.delivery_date_timezone).format('HH:mm') }} {{ $t('bin.till') }} {{ $moment.unix(parseInt(item.delivery_date_till)).tz(item.delivery_date_timezone).format('HH:mm') }}</p>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.delivery_from') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.delivery_date_from)).tz(item.delivery_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                                <div class="col-12 col-md-6 mb-15">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t(`shipments.times.${checkTime(item.delivery_date_from, item.delivery_date_till, item.delivery_date_timezone)}`) }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.delivery_date_from)).tz(item.delivery_date_timezone).format('HH:mm') }} {{ $t('bin.till') }} {{ $moment.unix(parseInt(item.delivery_date_till)).tz(item.delivery_date_timezone).format('HH:mm') }}</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <p class="mb-0 fs-12 font-weight-light">{{ $t('shipments.till') }}</p>
                                    <p class="mb-0 text-secondary">{{ $moment.unix(parseInt(item.delivery_date_till)).tz(item.delivery_date_timezone).format('DD MMMM YYYY') }}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-12">
                                    <disclaimer>{{ $t('shipments.deliverytimezonedisclaimer', { tz: item.delivery_date_timezone }) }}</disclaimer>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-map-container">
                        <div class="map-info-container">
                            <div class="map-info-box">
                                <i-watch class="i-30 mr-15"></i-watch>{{ routeDuration }}
                            </div>
                            <div class="map-info-box">
                                <i-distance class="i-30 mr-15"></i-distance>{{ Math.round((item.route.distance / 1000).toFixed(1)) }} km
                            </div>
                        </div>
                        <GmapMap ref="gmap" :center="center" :zoom="11" map-type-id="roadmap" :options="options" style="width: 100%; height: 200px;">
                            <gmap-polyline v-if="item.route" :path="decodeRoute(item.route.points, true)" :options="{geodesic:true, strokeColor:'#48616f', strokeOpacity: 0, icons: [{ icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 4 }, offset: '0', repeat: '25px' }]}">
                            </gmap-polyline>
                            <gmap-marker v-for="(marker, key) in markers" :key="key" :position="marker.position" :icon="marker.icon"></gmap-marker>
                        </GmapMap>
                    </div>

                </template>
            </box>

            <!-- Detail information -->
            <!-- Package types, images -->
            <box class="detail-box" :padding="0">
                <template slot="content">
                    <div class="row detail-row" :class="{ open: openDetail === key }" @click="openDetail = key" v-for="(pack, key) in item.packages" :key="pack.id">
                        <!-- Header -->
                        <div class="col-12 header">
                            <div class="row my-grid">
                                <div class="col-12 d-flex">
                                    <component class="i-30 mr-30" :is="'package-' + pack.type"></component>
                                    <div class="text-secondary">{{ $t(`shipments.packages.types.${pack.type}`) }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Body -->
                        <div class="content col-12">
                            <div class="row py-grid">
                                <div class="col-12 col-md-6">

                                    <div class="row mb-30">
                                        <div class="col-3">
                                            <p class="mb-0 fs-12">{{ $t('bin.length') }}</p>
                                            <p class="mb-0 text-secondary">{{ pack.length }} cm</p>
                                        </div>
                                        <div class="col-3">
                                            <p class="mb-0 fs-12">{{ $t('bin.width') }}</p>
                                            <p class="mb-0 text-secondary">{{ pack.width }} cm</p>
                                        </div>
                                        <div class="col-3">
                                            <p class="mb-0 fs-12">{{ $t('bin.height') }}</p>
                                            <p class="mb-0 text-secondary">{{ pack.height }} cm</p>
                                        </div>
                                        <div class="col-3">
                                            <p class="mb-0 fs-12">{{ $t('bin.weight') }}</p>
                                            <p class="mb-0 text-secondary">{{ pack.weight }} kg</p>
                                        </div>
                                    </div>

                                    <template v-if="pack.attachments.length !== 0">
                                        <div class="row mb-30" v-if="pack.description">
                                            <div class="col-12">
                                                <p class="mb-0 fs-12">{{ $t('shipments.packages.description') }}</p>
                                                <p class="mb-0 text-secondary">{{ pack.description }}</p>
                                            </div>
                                        </div>

                                        <div class="row" v-if="pack.tags.length">
                                            <div class="col-12">
                                                <p class="fs-12">{{ $t('shipments.tags.tags') }}</p>
                                            </div>
                                            <div class="col-6" v-for="(tag, key) in pack.tags" :key="key">
                                                <component class="i-30 mr-10" :is="getExtraType(getExtraSlug(tag))"></component>
                                                {{ $t('shipments.tags.' + getExtraSlug(tag), { min: getMinMaxTemp(tag, 1) , max: getMinMaxTemp(tag, 2)}) }}
                                            </div>
                                        </div>
                                    </template>

                                </div>

                                <!-- If the package has at least 1 image -->
                                <!-- Show the image at the right side -->
                                <div v-if="pack.attachments.length > 0" class="col-12 col-md-6 detail-images">
                                    <div class="main-image">
                                        <img class="viewable-img" :src="getImage(pack.attachments[0].image.original.url)">
                                    </div>
                                    <div class="images">
                                        <img v-for="(img, key) in pack.attachments" :key="key" class="extra-image viewable-img" :src="getImage(img.image.original.url)" />
                                    </div>
                                </div>

                                <!-- If the package has at no images -->
                                <!-- Show the description at the right side -->
                                <div class="col-12 col-md-6" v-else>
                                    <div class="row mb-30" v-if="pack.description">
                                        <div class="col-12">
                                            <p class="mb-0 fs-12">{{ $t('shipments.packages.description') }}</p>
                                            <p class="mb-0 text-secondary">{{ pack.description }}</p>
                                        </div>
                                    </div>

                                    <div class="row" v-if="pack.tags.length">
                                        <div class="col-12">
                                            <p class="fs-12">{{ $t('shipments.tags.tags') }}</p>
                                        </div>
                                        <div class="col-6" v-for="(tag, key) in pack.tags" :key="key">
                                            <component class="i-30 mr-10" :is="getExtraType(getExtraSlug(tag))"></component>
                                            {{ $t('shipments.tags.' + getExtraSlug(tag), { min: getMinMaxTemp(tag, 1) , max: getMinMaxTemp(tag, 2)}) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </template>
            </box>

            <!-- Driver name, lisence, rating -->
            <box class="mt-45 mb-45" v-if="driver" :padding="30">
                <template slot="content">
                    <div class="d-flex flex-wrap">

                        <div class="d-flex border-right pr-30 mr-30 my-auto">
                            <component class="i-80 mr-15" :is="getCarType(driver.driver.cars[0].car_type_id)"></component>
                            <div class="my-auto">
                                <p class="mb-0 fs-20 fw-semi-bold text-secondary driver-car-text">{{ $t(`cars.${getCarType(driver.driver.cars[0].car_type_id)}`) }}</p>
                                <p class="mb-0 fs-12 text-uppercase">{{ driver.driver.cars[0].license_plate }}</p>
                            </div>
                        </div>

                        <div class="d-flex mb-30 my-auto">
                            <profile-image class="mr-30 my-auto" :size="45" :user="driver"></profile-image>
                            <div>
                                <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ driver.first_name + ' ' + driver.last_name}} <a class=" text-primary fs-12 ml-15 v-align-middle my-atuo" href="#" @click="showAddDriverPopup = true" v-if="isStateAfter('unloaded', item.current_state.state)">{{ $t('bin.change') }}</a></p>
                                <rating :total="driver.driver_rating_total" :count="calcStars(driver.driver_rating_count, driver.driver_rating_total)" :showCount="false"></rating>
                            </div>
                        </div>

                        <div class="d-flex my-auto ml-auto">
                            <a :href="'tel:' + driver.cellphone" class="btn btn-outline-body-bg fs-12 mr-15 px-15">{{ driver.cellphone }}</a>
                            <a :href="'mailto:' + driver.email" class="btn btn-outline-body-bg fs-12 px-15">{{ driver.email }}</a>
                        </div>
                    </div>
                </template>
            </box>

        </div>

        <!-- Right (Side) panel -->
        <!-- Contains states, company -->
        <!-- offers, drivers -->
        <div class="col-12 col-md-4">

            <!-- States -->
            <!-- State list and edit state -->
            <box v-if="item.states" class="mb-45 states" :padding="0" :class="{ open : openStates }" @click="openStates = !openStates">
                <template slot="content">
                    <!-- <div class="state d-flex" v-for="(state, index) in orderedStates" :key="index" :class="{ active : state.state === currentState.state, collapsed: (isStateAfter(currentState.state, 'delivered') && (state.state !== 'new' && state.state !== 'finalised' && state.state !== 'invoicereceived' && state.state !== 'paid')) }"> -->
                    <div class="state d-flex" v-for="(state, index) in orderedStates" :key="index" :class="{ active : state.state === currentState.state, collapsed: currentState.state !== state.state  && state.state !== 'new'}">

                        {{ $t('states.' + state.state) }}
                        <span class="ml-auto date">{{ state.created_at | moment(`D/M/Y [${ $t('bin.at') }] H:mm`) }}</span>
                    </div>
                    <div class="state new-state text-center" @click.stop="showStatePopup = true" v-if="!isStateAfter(item.current_state.state, 'unloaded') && item.accepted_offer.assigned">{{ $t('shipments.changestate') }}</div>
                </template>
            </box>

            <!-- Ratings -->
            <!-- Show and give ratings -->
            <box class="mb-45" v-if="isStateAfter(item.current_state.state, 'delivered')">
                <template slot="content">
                    <div class="row">
                        <div class="col-12 d-flex">
                            <p class="mb-0 fs-14">{{ $t('states.received') }}:</p>
                            <rating class="ml-auto" :count="ratingReceived" :showCount="false"></rating>
                        </div>
                        <div class="col-12">
                            <div class="my-15 border-bottom border-light w-100"></div>
                        </div>
                        <div class="col-12 d-flex">
                            <p class="mb-0 fs-14">{{ $t('states.given') }}:</p>
                            <rating class="ml-auto" :count="ratingGiven" :showCount="false" :readonly="false" @updated="handleRatingGiven"></rating>
                        </div>
                    </div>
                </template>
            </box>

            <!-- Pending documents -->
            <!-- File upload -->
            <box class="mb-45" v-if="currentState.state === 'delivered' || currentState.state === 'finalised'">
                <template slot="content">
                    <p class="mb-15 fs-16 fw-semi-bold text-secondary">{{ $t('states.pendingcmr')}}</p>
                    <dropzone @uploaded="getMyShipments" :shipment="item" :imageOnly="false"></dropzone>
                </template>
            </box>

            <box class="mb-45" v-if="!isStateAfter('delivered', currentState.state) && item.attachments.length > 0">
                <template slot="content">
                    <div class="row mb--15">
                        <div class="col-12">
                            <p class="mb-15 fs-16 fw-semi-bold text-secondary">{{ $t('shipments.pods')}}</p>
                        </div>
                        <div v-for="attachment in item.attachments" :key="attachment.id" class="col-6 mb-15">
                            <div class="d-flex">
                                <div v-if="currentState.state === 'delivered' || currentState.state === 'finalised'" class="attachment-icon-remove" @click="destroyAttachment(attachment)">✖</div>
                                <img class="attachment-icon mr-15" :src="getImage(attachment.image.medium.url)" alt="">
                                <div class="d-flex flex-wrap">
                                    <a :href="getImage(attachment.image.original.url)" target="_blank" class="fs-12 text-primary">{{ $t('shipments.view_attachment')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </box>

            <!-- Ready for invoice -->
            <!-- Display all pending invoice data  -->
            <box class="mb-45" v-if="isStateAfter(currentState.state, 'finalised')">
                <template slot="content" v-if="item.accepted_offer.cost_breakdown_driver.hasOwnProperty('adminfee')">
                    <div class="row mb-30">
                        <div class="col">
                            <p class="mb-5 fs-16 fw-bold text-secondary">{{ $t('bin.amount') }}</p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('shipments.transportcost') }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.route }}</span></p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('offer.discount.' + item.accepted_offer.driver_payment_type) }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.discount.amount }}</span></p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('offer.adminfee', [item.accepted_offer.cost_breakdown_driver.adminfee.pct]) }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.adminfee.amount }}</span></p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('offer.total') }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.total.withdiscountbeforetaxes }}</span></p>
                            <p class="mb-0 fs-14 d-flex fw-semi-bold">{{ $t('offer.totalvat', [item.accepted_offer.cost_breakdown_driver.vat]) }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.total.withdiscountaftertaxes }}</span></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                             <div class="text-green fs-12 d-flex mb-15 mt-15">
                                <i-info class="icon my-auto mr-10 flex-none"></i-info>
                                <span class="my-auto" v-html="$t('offer.selfbilling')"></span>
                            </div>
                        </div>
                    </div>
                </template>
                <template slot="content" v-else>
                    <div class="d-flex mb-30">
                        <p class="mb-15 fs-16 fw-semi-bold my-auto text-secondary">{{ $t('shipments.invoicereference') }}</p>
                        <div class="btn btn-primary btn-sm my-auto ml-auto fs-14 fw-semi-bold text-uppercase">{{ item.reference_id }}</div>
                    </div>
                    <div class="row mb-30">
                        <div class="col">
                            <p class="mb-0 fw-semi-bold text-secondary mb-5">{{ $t('bin.company') }}</p>
                            <p class="mb-0 fs-14">Vengo BVBA</p>
                            <p class="mb-0 fs-14"><a href="mailto:info@vengo.technology">info@vengo.technology</a></p>
                            <p class="mb-0 fs-14">BE 0636.989.039</p>
                        </div>
                        <div class="col ml-auto text-right">
                            <p class="mb-0 fw-semi-bold text-secondary mb-5">{{ $t('bin.address') }}</p>
                            <p class="mb-0 fs-14">Ambachtsweg 11</p>
                            <p class="mb-0 fs-14">3890 Gingelom</p>
                            <p class="mb-0 fs-14">BELGIUM</p>
                        </div>
                    </div>

                    <div class="row mb-30">
                        <div class="col">
                            <p class="mb-5 fs-16 fw-bold text-secondary">{{ $t('bin.amount') }}</p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('shipments.transportcost') }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.route }}</span></p>
                            <p class="mb-0 fs-14 d-flex">{{ $t('offer.discount.' + item.accepted_offer.driver_payment_type) }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.discount.amount }}</span></p>
                            <p class="mb-0 fs-14 d-flex fw-semi-bold">{{ $t('offer.total') }}: <span class="ml-auto">€ {{ item.accepted_offer.cost_breakdown_driver.total.withdiscountbeforetaxes }}</span></p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <disclaimer>{{ $t('offer.invoicereferencedisclaimer') }}</disclaimer>
                        </div>
                    </div>
                </template>
            </box>

            <!-- Sender -->
            <!-- Sender name, rating, contact -->
            <box v-if="item.user" class="mb-45">
                <template slot="content">
                    <div class="row">
                        <div class="driver-tag text-uppercase fw-bold py-5 px-10 fs-12">Sender</div>
                        <div class="col-12 text-center">
                            <profile-image :size="90" class="mb-15 mx-auto" :user="item.user"></profile-image>
                            <p class="mb-0 fs-20 fw-semi-bold text-secondary">{{ item.user.first_name }} {{ item.user.last_name }}</p>
                            <p class="mb-15 fs-12" v-if="item.user.company">{{ item.user.company.name }}</p>
                        </div>

                        <div class="col-12 text-center">
                            <rating :total="item.user.sender_rating_total" :count="calcStars(item.user.sender_rating_count, item.user.sender_rating_total)"></rating>
                        </div>

                        <!-- Offer approved -->
                        <div v-if="item.offer_id" class="col-12 mt-30">
                            <div class="row">
                                <div class="col-6 pr-15">
                                    <a class="btn btn-outline-primary btn-block" :href="'tel:' + item.user.cellphone">{{ item.user.cellphone }}</a>
                                </div>
                                <div class="col-6 pl-15">
                                    <router-link class="btn btn-primary btn-block" active-class="active" :to="{ name: 'chat', query: { id: item.id } }">Chat</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </box>

            <!-- Offers -->
            <!-- Status, price -->
            <box class="mb-45" v-if="item.offer_made && !item.offer_id">
                <template slot="content">
                    <!-- Offer approved -->
                    <template>
                        <div class="row mb-15">
                            <div class="col">
                                <p class="mb-0 fs-20 fw-bold text-secondary">{{ $t('shipments.offer.made') }}</p>
                            </div>
                            <div class="col text-right fs-12 d-flex">
                                <p class="my-auto w-100">{{ $moment.unix(item.offers[0].created_at).fromNow() }}</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col text-secondary d-flex">
                                <p class="my-auto">&euro; {{ item.offers[0].price.toFixed(2) }}</p>
                            </div>
                            <div class="col">
                                <button class="btn btn-body-bg btn-block fw-semi-bold" @click.prevent="cancelOffer(item.offers[0].id)">{{ $t('shipments.offer.cancel') }}</button>
                            </div>
                        </div>
                    </template>
                </template>
            </box>

            <box class="mb-45" v-if="!item.offer_made">
                <template slot="content">
                    <!-- Offer open -->
                    <template>
                        <p class="mb-15 fs-20 fw-bold text-secondary">{{ $t('shipments.offer.placecta') }}</p>
                        <form @submit.prevent="validateAndPlaceOffer">
                            <div class="form-row">
                                <div class="form-group col-7 pr- mb-0">
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">€</span>
                                        </div>
                                        <input v-model="offer.value" name="offer" v-validate="'required|min_value:' + Object.values(item.cars)[0].price_indication.fork.min + '|max_value:' + Object.values(item.cars)[0].price_indication.fork.max" step="0.5" type="number" class="form-control form-control-sm text-right mb-10" id="offer">
                                    </div>
                                </div>
                                <div class="form-group col-5 mb-0">
                                    <button class="btn btn-primary btn-block submit">{{ $t('shipments.offer.placebuttoncaption') }}</button>
                                </div>
                            </div>
                            <div class="form-row">
                                <label class="mb-0 fs-12 pl-15" :class="{ 'text-danger': errors.has('offer') }" for="offer">{{ $t('shipments.offer.range', { min: Object.values(item.cars)[0].price_indication.fork.min, max: Object.values(item.cars)[0].price_indication.fork.max }) }}</label>
                            </div>
                        </form>
                    </template>
                </template>
            </box>
        </div>

        <image-previewer :images="this.images" targetClass="viewable-img"></image-previewer>

        <!-- Popups -->
        <popup-edit-states :show="showStatePopup" :shipment="item" @close="showStatePopup = false"></popup-edit-states>

        <popup-add-driver :show="showAddDriverPopup" :drivers="availableFleetDrivers" :shipment="item" @close="showAddDriverPopup = false" @assigned="assignDriverToShipment"></popup-add-driver>

    </div>
</template>

<script>
const mapstyle = require("@/assets/mapstyles.json");

import Rating from "@/components/elements/rating";
import ImagePreviewer from "@salamander.be/vue-image-previewer";
import Dropzone from "@/components/elements/dropzone";
import Disclaimer from "@/components/elements/disclaimer";
import { mapActions, mapGetters } from "vuex";
import { PopupAddDriver, PopupEditStates } from "@/components/popups/_index";

export default {
    name: "shipment-detail",
    components: {
        Rating,
        ImagePreviewer,
        PopupAddDriver,
        PopupEditStates,
        Dropzone,
        Disclaimer
    },
    data() {
        return {
            backText: "",
            offer: {
                value: null
            },
            markers: [],
            openStates: true,
            driverRoute: false,
            suggestedRoute: false,
            showStatePopup: false,
            showAddDriverPopup: false,
            openDetail: 0,
            searchDriver: "",
            center: { lat: 50.93069, lng: 5.33248 },
            options: {
                styles: mapstyle,
                scrollwheel: false,
                disableDefaultUI: true,
                zoomControl: false
            },
            type: ""
        };
    },

    /* 
    | --------------
    | When mounted, check the current shipment type
    | and display the correct back message
    | --------------
    */
    mounted() {
        this.getMyShipments();
        this.type = this.$route.meta.type;
        if (this.type === "shipment") {
            this.backText = this.$t('layout.myshipments');
        }
        if (this.type === "search") {
            this.backText = this.$t('layout.search');
        }
        if (this.type === "offer") {
            this.backText = this.$t('layout.offers');
        }

        this.$nextTick().then(() => {
            if (this.item) this.initMarkers(this.item);
        });

        if (!this.item.offer_id && !this.offer.value) {
            this.offer.value = Object.values(
                this.item.cars
            )[0].price_indication.selected;
        }
    },
    methods: {
        ...mapActions([
            "placeOffer",
            "cancelOffer",
            "assignDriver",
            "deleteAttachment",
            "getMyShipments",
            "rateSender"
        ]),

        /* 
        | --------------
        | Initialise google markers
        | --------------
        */
        initMarkers(shipment) {
            let pickup_marker = {
                position: {
                    lat: shipment.pickup_location.lat,
                    lng: shipment.pickup_location.lng
                },
                icon: this.getMarker("green")
            };
            let destination_marker = {
                position: {
                    lat: shipment.delivery_location.lat,
                    lng: shipment.delivery_location.lng
                },
                icon: this.getMarker("orange")
            };

            this.markers.push(pickup_marker);
            this.markers.push(destination_marker);
            this.$nextTick().then(() => {
                let self = this;
                // At this point, the child GmapMap has been mounted, but
                // its map has not been initialized.
                // Therefore we need to write gmap.$mapPromise.then(() => ...)
                this.$gmapApiPromiseLazy().then(() => {
                    this.$refs.gmap.$mapPromise.then(() => {
                        self.fitBounds();
                        self.drawSuggestedRoute();
                        self.drawDriverRoute();
                    });
                });
            });
        },

        /* 
        | --------------
        | Zoom map to show all markers
        | --------------
        */
        fitBounds() {
            let bounds = new google.maps.LatLngBounds();
            this.markers.forEach(marker => {
                bounds.extend(marker.position);
            });
            this.$refs.gmap.fitBounds(bounds);
            this.center = {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng()
            };
        },

        /* 
        | --------------
        | Draw the suggested route
        | --------------
        */
        drawSuggestedRoute() {
            if (this.item.route) {
                this.suggestedRoute = this.decodeRoute(
                    this.item.route.points,
                    true
                );
            }
        },

        /* 
        | --------------
        | Draw the drivers route
        | --------------
        */
        drawDriverRoute() {
            if (this.item.driver_route) {
                this.driverRoute = this.decodeRoute(
                    this.item.driver_route.points,
                    true
                );
            }
        },

        handleRatingGiven(rating) {
            let data = {
                rating: rating,
                shipment_id: this.item.id,
                user_id: this.item.accepted_offer.user_id
            };
            // TODO Jan: fix rate action
            this.rateSender(data).then(res => {});
        },

        assignDriverToShipment(driver_id) {
            this.assignDriver({
                shipment_id: this.item.id,
                offer_id: this.item.offer_id,
                driver_id: driver_id
            });
        },
        validateAndPlaceOffer() {
            this.$validator
                .validate()
                .then(res => {
                    if (res) {
                        this.placeOffer({
                            shipment_id: this.item.id,
                            price: this.offer.value
                        })
                            .then(() => {
                                console.log("success");
                            })
                            .catch(err => {
                                console.log(err.response);
                            });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        getMinMaxTemp(tag, idx) {
            if (tag.includes("refrigerated") || tag.includes("frozen")) {
                let exploded = tag.split("_");
                return exploded[idx];
            } else {
                return false;
            }
        },

        destroyAttachment(attachment) {
            this.deleteAttachment(attachment)
                .then(res => {
                    this.getMyShipments();
                    if (res.hasOwnProperty("message")) {
                        this.$toasted.show(res.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    computed: {
        ...mapGetters(["allFleetDrivers", "user"]),
        routeDuration() {
            return (
                Math.floor(
                    this.$moment
                        .duration(this.item.route.duration, "seconds")
                        .asHours()
                ) +
                ":" +
                this.$moment
                    .duration(this.item.route.duration, "seconds")
                    .minutes()
            );
        },

        item() {
            if (this.type === "shipment") {
                return this.$store.getters.currentmyshipment(
                    this.$route.params.shipmentId
                );
            } else {
                return this.$store.getters.currentnewshipment(
                    this.$route.params.shipmentId
                );
            }
        },

        /* 
        | --------------
        | Generate a list of images to show in the image previewer
        | --------------
        */
        images() {
            let images = [];
            this.item.packages.forEach(p => {
                p.attachments.forEach(attachment => {
                    images.push(this.getImage(attachment.image.original.url));
                });
            });
            return images;
        },

        driver() {
            return this.item.hasOwnProperty("accepted_offer") &&
                this.item.accepted_offer.assigned
                ? this.$store.getters.getDriver(
                      this.item.accepted_offer.user_id
                  )
                : false;
        },

        availableFleetDrivers() {
            return this.driver
                ? this.allFleetDrivers.filter(driver => {
                      return driver.id !== this.driver.id;
                  })
                : this.allFleetDrivers;
        },

        currentState() {
            return this.orderedStates.slice(-1)[0];
        },

        orderedStates() {
            let ordered = [];

            if (this.item.hasOwnProperty("states")) {
                ordered = this.item.states.slice().reverse();

                if (
                    this.item.accepted_offer.driver_invoice_received !==
                    "0000-00-00"
                ) {
                    ordered.push({
                        state: "invoicereceived",
                        created_at: this.item.accepted_offer
                            .driver_invoice_received
                    });
                }

                if (
                    this.item.accepted_offer.driver_invoice_paid !==
                    "0000-00-00"
                ) {
                    ordered.push({
                        state: "paid",
                        created_at: this.item.accepted_offer.driver_invoice_paid
                    });
                }
            } else {
                ordered.push(this.item.current_state);
            }

            return ordered;
        },

        ratingReceived() {
            if (this.isStateAfter(this.item.current_state.state, "delivered")) {
                let found = this.item.ratings.find(
                    rating => rating.author_id === this.item.user_id
                );
                return found ? found.rating : 0;
            }
            return 0;
        },

        ratingGiven() {
            if (this.isStateAfter(this.item.current_state.state, "delivered")) {
                let found = this.item.ratings.find(
                    rating =>
                        rating.author_id === this.item.accepted_offer.user_id
                );
                return found ? found.rating : 0;
            }
            return 0;
        }
    }
};
</script>
